export default {
  'cfdSettings.title': 'CFD Settings',
  'cfdSettings.onlyDisplayBillTotal': 'Only display bill total when making a payment',
  'cfdSettings.updateSuccess': 'Successfully updated settings',
};
